/**
 * Item Master `description` / quote `itemDetails` should not repeat room/space labels
 * (legacy BHK template rows stored space names in description).
 */
export function cleanMasterDescription(description, defaultSpace) {
  const d = String(description ?? '').trim();
  if (!d) return '';
  const t = d.toLowerCase();
  if (t === "children's bedroom" || t === 'childrens bedroom' || t === 'guest room' || t === 'guest bedroom' || t === 'master bedroom 2' || t === 'masterbedroom 2') return '';
  const sp = String(defaultSpace ?? '').trim().toLowerCase();
  if (sp && t === sp) return '';
  return d;
}
